import { defineComponent as _defineComponent } from 'vue'
import { useAnimate } from '~/lib/composables/useAnimate'


export default /*#__PURE__*/_defineComponent({
  __name: 'WavesBackgroundCanvas',
  setup(__props) {

const COLORS = ['#347fd4', '#196bda', '#2754da', '#4834D4']
const WAVE_RESOLUTION = 40
const NUM_WAVES = 4

useAnimate((ticks) => {
  const canvas = document.getElementById('wavesCanvas') as HTMLCanvasElement
  const ctx = canvas.getContext('2d')!
  const width = window.innerWidth
  const height = window.innerHeight
  const bandThickness = height / 7

  canvas.height = height
  canvas.width = width
  ctx.clearRect(0, 0, width, height)
  ctx.scale(2, 2)

  for (let i = 0; i < NUM_WAVES; i++) {
    const yOffset = bandThickness * i + 25

    ctx.beginPath()
    ctx.moveTo(-50, yOffset)

    for (let j = 0; j < WAVE_RESOLUTION; j++) {
      const x = (j * width) / WAVE_RESOLUTION - 50

      const p = (fn: (n: number) => number, a: number, b: number, c: number) =>
        fn((1 + j * 2 + ticks) / a + j / b) * c

      const y =
        p(Math.sin, 30, 4, 8) +
        p(Math.sin, 40, 2, 10) +
        p(Math.cos, 50, 8, 4) +
        yOffset

      ctx.lineTo(x, y)
    }

    ctx.lineWidth = bandThickness
    ctx.strokeStyle = COLORS[i]
    ctx.stroke()
    ctx.closePath()
  }
})

return { __sfc: true,COLORS, WAVE_RESOLUTION, NUM_WAVES }
}

})